<div class="top-section">
    <h6 class="heading mb-0">{{ ss.t('calendarEvent_titleTopBar') }}
        <span class="text-10-400 color-27 ri-ps-2 ri-pe-3">{{
            ss.getFormattedDate(data.dateString, 'EEE, d MMM') }}</span>
    </h6>
    <div class="flex items-center gap-6">
        <app-svg name="more" class="more-icon" [matMenuTriggerFor]="infoMenu" role="button"
            *ngIf="data.mode === 'edit'" [color]="ss.theme().color12"></app-svg>
        <mat-menu yPosition="above" xPosition="before" #infoMenu="matMenu" class="me-menu info-menu ri-w-350px">
            <button mat-menu-item class="text-14-400 color-8" (click)="openCalendarAccountForm()">
                <app-svg name="edit" [color]="ss.theme().color35" class="ri-me-3 icon-mirror-rtl"></app-svg>
                <span class="w-full">{{ ss.t('calendarAccount_title') }}</span>
            </button>
        </mat-menu>

        <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
    </div>
</div>
<div class="calendar-event-form ri-p-4">
    <form [formGroup]="calendarEventForm" #cEventForm="ngForm" class="flex flex-col gap-6">
        <div class="flex justify-between items-center">
            <app-input-text [control]="getFc('title')" name="meCalendarEventTitle"
                [placeholder]="ss.t('common_titlePlaceholder')" [readonly]="true"
                (click)="openAlert()"></app-input-text>
            <app-svg name="calendarIntegration" [color]="ss.theme().color7"
                style="height: 24px; width: 24px;"></app-svg>
        </div>

        <div class="flex items-start w-full" (click)="openAlert()" role="button" *ngIf="hasDescription('description')">
            <app-svg name="description" [color]="ss.theme().color35" class="ri-pe-4 icon-mirror-rtl"></app-svg>

            <div [innerHTML]="getdecHtml('description')" class="description-content me-input-textarea w-full">
            </div>
        </div>

        <app-input-date-period name="meCalendarEventDateRange" [startControl]="getFc('startDate')"
            [endControl]="getFc('endDate')" [repeatControl]="getFc('repeat')" [readonly]="true" (click)="openAlert()"
            [dueDate]="dueDate()" [selectedDateString]="this.selectedDate()"></app-input-date-period>

        <app-input-time [control]="getFc('startDate')" [startTimeControl]="getFc('startTime')" [isTzAffected]="getFc('isTzAffected')"
            [isStartTimeSet]="getFc('isStartTimeSet')" [duration]="getFc('duration')" [reminder]="getFc('reminderAt')"
            [readonly]="true" (click)="openAlert()"></app-input-time>
        <app-input-reminder c [control]="getFc('reminderAt')" *ngIf="calendarEventForm.value.isStartTimeSet"
            [readonly]="true" (click)="openAlert()"></app-input-reminder>

        <a class="flex items-start" *ngIf="rawData()?.hangoutLink || rawData()?.onlineMeetingUrl"
            (click)="openMeetLink()" role="button">
            <app-svg [name]="calendarType() === 'google' ? 'googleMeet' : 'teamsMeet'"
                [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 block color-35 mb-0 ri-pb-2">{{ calendarType() === 'google' ?
                    ss.t('calendarEvent_googleMeetText') :
                    ss.t('calendarEvent_teamsMeetText') }}</p>
            </div>
        </a>
        <div class="flex items-start" (click)="openLocation()" *ngIf="eventData().location" role="button">
            <app-svg name="location" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0">{{ eventData().location }}</p>
            </div>
        </div>
        <div class="flex items-start" (click)="openAlert()">
            <app-svg name="calendarIntegration" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0 ri-pb-2">{{ eventData().calendarName }}</p>
                <p class="text-12-400 color-7 mb-0">{{ calendarAccount().email }}</p>
            </div>
        </div>
        <div class="flex items-start" (click)="openAlert()" *ngIf="rawData()?.showAs">
            <app-svg name="briefCase" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0 capitalize">{{ rawData().showAs }}</p>
            </div>
        </div>
        <div class="flex items-start ri-pb-5" (click)="openAlert()" *ngIf="rawData()?.sensitivity">
            <app-svg name="lock" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0 capitalize">{{ rawData().sensitivity }}</p>
            </div>
        </div>
    </form>
</div>
<div class="bottom-section flex items-center justify-end ri-p-4 ri-bt-2">
    <button type="submit" class="btn-text text-16-500 color-35" (click)="closeDialog()">{{
        ss.t('common_close') }}</button>
</div>